




























import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class LocaleSwitcher extends Vue {

    get locales() {
        return [
            { name: 'Deutsch', abbr: 'de', icon: require('../../assets/images/lang/de.png') },
            { name: 'English', abbr: 'en', icon: require('../../assets/images/lang/en.png') }
        ];
    }

    public switchLocale(locale: string) {
        if (this.$root.$i18n.locale !== locale) {
            this.$root.$i18n.locale = locale;
        }
    }
}
